import { useTranslation } from 'react-i18next';
import { ArrowLongRightIcon } from '@heroicons/react/24/solid';
import { ArrowLongLeftIcon } from '@heroicons/react/24/outline';
import classNames from '../utils/classList.utils';
import { useEffect, useRef } from 'react';

interface StepPaginationProps {
  step: number;
  setStep: (step: number) => void;
  steps: string[];
  anchor?: string;
}

const StepPagination = ({
  step,
  setStep,
  steps,
  anchor,
}: StepPaginationProps) => {
  const { t } = useTranslation();
  const firstRender = useRef(true);

  const scrollToId = (id: string) => {
    const element = document.getElementById(id);
    element && element.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (anchor) {
      scrollToId(anchor);
    }
  }, [step, anchor]);

  return (
    <div
      className={classNames(
        'flex',
        step > 1 ? 'justify-between' : 'justify-end'
      )}
    >
      {step > 1 && (
        <button
          onClick={() => setStep(step - 1)}
          className='px-4 py-2 paragraph text-left flex gap-2'
        >
          <ArrowLongLeftIcon className='w-6' />
          <div>
            <span className='font-bold'>
              {t('common.viewStep', { step: step - 1 })}
            </span>
            <span className='block'>{steps[step - 2] && steps[step - 2]}</span>
          </div>
        </button>
      )}
      {step < steps.length && (
        <button
          onClick={() => setStep(step + 1)}
          className='px-4 py-2 paragraph text-right flex gap-2'
        >
          <div>
            <span className='font-bold'>
              {t('common.viewStep', { step: step + 1 })}
            </span>
            <span className='block'>{steps[step] && steps[step]}</span>
          </div>
          <ArrowLongRightIcon className='w-6' />
        </button>
      )}
    </div>
  );
};

export default StepPagination;
